module.exports = __webpack_public_path__ + "3df3a9723c3eb95b55db66104f8b347a.png";